import { BaseSeratoFilter } from '@/pixi/filters/BaseSeratoFilter'
import * as PIXI from 'pixi.js'
import { useProjectStore } from '@/store/project-store'
import { EffectState } from '@/pixi/filters/types'

interface DisplacementUniforms {
  displacementMap: PIXI.Texture
  isAudioReactive: boolean
  audioIntensity: number
  displacementFactor: [number, number]
}
interface TextureUrls {
  [key: string]: string;
}

const textUrls: TextureUrls = {
  portrait: 'https://static.serato.com/visualizer/videos/wobble-portrait.mp4',
  landscape: 'https://static.serato.com/visualizer/videos/wobble-landscape.mp4',
  square: 'https://static.serato.com/visualizer/videos/wobble-landscape.mp4'
}
interface Textures {
  [key: string]: PIXI.Texture;
}

const textures: Textures = {}

export class DisplacementFilter extends BaseSeratoFilter {
  get uniforms (): DisplacementUniforms {
    return super.uniforms as DisplacementUniforms
  }

  private projectStore = useProjectStore()

  constructor (effectState: EffectState) {
    const shader = `
    varying vec2 vTextureCoord;
    uniform sampler2D uSampler;

    uniform sampler2D displacementMap;
    uniform bool isAudioReactive;
    uniform float audioIntensity;
    uniform vec2 displacementFactor;

    void main(void)
    {
      float canvasZoom = 1.0 / (1.0 - displacementFactor.x);
      vec2 offsetFactor = isAudioReactive ? (audioIntensity * displacementFactor) : displacementFactor;
      vec2 offset = vec2(texture2D(displacementMap, vTextureCoord).r) * offsetFactor;
      gl_FragColor = texture2D(uSampler, (vTextureCoord / canvasZoom) + offset);
    }`

    Object.entries(textUrls).forEach(([key, value]) => {
      textures[key] = BaseSeratoFilter.urlToTexture(value)
    })

    const uniforms: DisplacementUniforms = {
      displacementMap: textures['portrait'],
      isAudioReactive: false,
      audioIntensity: 0.1,
      displacementFactor: [0.1, 0.1]
    }

    super(
      effectState,
      undefined,
      shader,
      uniforms
    )
  }

  updateUniforms (): void {
    this.uniforms.audioIntensity = this.getAudioIntensityValue()
    this.uniforms.isAudioReactive = this.effectState.audioReactivityEnabled
    this.uniforms.displacementFactor = [this.effectState.intensity * 0.5, this.effectState.intensity * 0.5]
    this.uniforms.displacementMap = textures[this.projectStore.orientation]
  }
}
